import {normalizeTimestemp} from "../../../utils/normalizeTimestemp";
import {Button} from "react-bootstrap";
import React, {useState} from "react";
import axios from "axios";
import {ApiUrl} from "../../../auth/authMethods";
import FileInput from "../../../component/FileInput/FileInput";
import Textarea from "@mui/joy/Textarea";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

export default function WriteOffForm({
                                         item, setNeedToReload, isLoading, setIsLoading, setError, handleClose
                                     }) {

    const [motivo, setMotivo] = useState('')
    const [anexos, setAnexos] = useState([])
    const [finalStatus, setFinalStatus] = useState('CANCELADA')

    const writeOff = (e) => {

        e.preventDefault()


        const formData = new FormData();
        formData.append('motivo', motivo);
        formData.append('finalStatus', finalStatus);
        for (let file of anexos) {
            formData.append('files', file);
        }

        setIsLoading(true)
        axios.put(ApiUrl + `/parcelas/baixa-manual/${item.id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then(() => {
                setNeedToReload(true)
            })
            .catch(() => {
                setError(true)
            }).finally(() => setIsLoading(false))
    }

    return <>
        <form action={writeOff} style={{textAlign: 'center'}}>
            <h4>Dados da parcela</h4>
            <p id="child-modal-description">
                <b>Id: </b>{item.id} &nbsp;
                <b>Parcela: </b>{item.numero} &nbsp;
                <b>Vencimento: </b>{normalizeTimestemp(item.vencimento, true)} &nbsp;
                <b>Valor: </b>{item.valor} &nbsp;
                <b>Status: </b>{item.status} &nbsp;
            </p>

            <hr/>
            <h4>Formulário de cancelamento</h4>

            <Textarea
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                required
                placeholder='Descreva com detalhes o assunto do contato'
                size="lg"
                variant="outlined"
                className="mt-3 mb-3"
                minRows={2}
                sx={{width: '70%', marginLeft: '15%'}}
            />

            <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">Status Final</FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={finalStatus}
                    onChange={(e) => setFinalStatus(e.target.value)}
                >
                    <FormControlLabel value="CANCELADA" control={<Radio/>} label="Cancelada"/>
                    <FormControlLabel value="PAGA_DIRETA" control={<Radio/>} label="Paga Direta"/>
                    <FormControlLabel value="PAGA" control={<Radio/>} label="Paga (irá gerar pagamento)"/>
                </RadioGroup>
            </FormControl>
            <br/>

            <FileInput
                selectedFile={anexos}
                setSelectedFile={setAnexos}
                multiple
            />

            <div className='text-center'>
                <Button
                    onClick={writeOff}
                    disabled={isLoading || (!motivo || !anexos.length > 0)}
                    className={isLoading ? "btn btn-secondary" : ""}
                >
                    {isLoading ? (<>
                          <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                          ></span>
                        &nbsp;Aguarde...
                    </>) : (<>Confirmar</>)}
                </Button>
                &nbsp;
                <Button
                    onClick={handleClose} variant='outline-secondary'
                >
                    Cancelar
                </Button>
            </div>
        </form>
    </>
}